export const selectDatarecommended = state =>
  state.recommendedFoodPage.recommendedFoodPage;
